import type { UnleashClient } from "unleash-proxy-client";

export const FEATURE_FLAGS_SYNC_CHANNEL = "sysigreja-feature-flags-sync";

export type FeatureFlagsSyncMessage = {
  type: "REFRESH";
  at: number;
};

/**
 * Força o cliente Unleash a buscar toggles de novo (sem aceitar 304) após alteração no backoffice.
 */
export async function refreshFeatureFlags(client: UnleashClient | null | undefined) {
  if (!client) return;

  const ctx = client.getContext();
  const { appName: _a, environment: _e, sessionId: _s, ...mutable } = ctx;

  (client as unknown as { etag?: string }).etag = "";

  await client.updateContext({
    ...mutable,
    properties: {
      ...mutable.properties,
      __ffRefresh: String(Date.now()),
    },
  });
}

export function broadcastFeatureFlagsRefresh() {
  if (typeof BroadcastChannel === "undefined") return;

  const channel = new BroadcastChannel(FEATURE_FLAGS_SYNC_CHANNEL);
  channel.postMessage({
    type: "REFRESH",
    at: Date.now(),
  } satisfies FeatureFlagsSyncMessage);
  channel.close();
}

export async function refreshFeatureFlagsEverywhere(client: UnleashClient | null | undefined) {
  await refreshFeatureFlags(client);
  broadcastFeatureFlagsRefresh();
}

export function subscribeFeatureFlagsSync(
  client: UnleashClient | null | undefined,
  onRefreshed?: () => void,
) {
  if (typeof BroadcastChannel === "undefined") return () => undefined;

  const channel = new BroadcastChannel(FEATURE_FLAGS_SYNC_CHANNEL);
  channel.onmessage = (event: MessageEvent<FeatureFlagsSyncMessage>) => {
    if (event.data?.type !== "REFRESH") return;
    void refreshFeatureFlags(client).then(() => onRefreshed?.());
  };

  return () => channel.close();
}
